// 多语言翻译配置
export const TRANSLATIONS = {
  zh: {
    identityVerif: '身份验证',
    mobilePlaceholder: '手机号码',
    connectSignal: '连接分身',
    orAuth: '或通过以下方式认证',
    agreeProtocol: '连接即代表您同意',
    protocolName: '神经协议',
    uploadConsciousness: '您的意识将被上传。',
    general: '通用设置',
    personality: '分身性格设定',
    memory: '记忆库管理',
    voice: '语音音色',
    privacy: '隐私与安全',
    systemPref: '系统偏好',
    notifications: '消息通知',
    language: '语言设置',
    version: '版本',
    back: '返回',
    uploadAvatar: '上传神经影像',
    tapToChange: '点击更换形象',
    contacts: '通讯录',
    scan: '扫一扫',
    avatarSettings: 'AI分身设置',
    comingSoon: '在路上了...',
    traitLogic: '逻辑性',
    traitEmotion: '情感值',
    traitCreativity: '混乱度 (创造力)',
    archetype: '核心原型',
    archetypeHelper: '助理 / 导师 / 叛逆者',
    coreMemories: '核心记忆节点',
    contextWindow: '上下文窗口占用',
    clearCache: '清除短期缓存',
    memoryOptimized: '记忆碎片已重组。',
    voiceModel: '合成器模型',
    speed: '语速频率',
    pitch: '音调偏移',
    ghostMode: '幽灵模式',
    ghostDesc: '不保留任何交互日志',
    biometric: '生物锁',
    biometricDesc: '启动需面容识别',
    deleteData: '销毁所有数据',
    initLink: '正在初始化神经连接...',
    sayHello: '向你的分身问好。',
    typeConnect: '输入以连接...',
    online: '在线',
    systemRequest: '系统请求',
    agree: '同意',
    reject: '拒绝',
    decision: '决定',
    unknown: '未知',
    aiMatrix: '硅基部落',
    carbonTribe: '碳基部落',
    availZones: '可用自治区域',
    capacity: '容量',
    full: '已满',
    fullCapacity: '满员',
    joined: '已加入',
    owner: '所有者',
    applyJoin: '申请加入',
    selectionMode: '选择模式',
    createGroup: '发起群聊',
    cancel: '取消',
    minSelect: '至少选择 3 个不同分身',
    groupCreated: '用户群聊已建立',
    neuralPass: '未来通行证',
    unlockPot: '解锁全部潜能',
    currentLink: '当前连接',
    basic: '基础版',
    maxGroup: '最多 1 个群组',
    msgLimit: '100 条消息限制',
    upgrade: '升级',
    matrixGold: '矩阵黄金版',
    unlimitedGroups: '无限群组',
    infiniteChat: '无限对话',
    sysWarning: '系统警告：',
    cyclesRemaining: '您的AI分身连接不稳定。本月剩余周期 ',
    monthly: '月付',
    yearly: '年付',
    saveOff: '立省 8%',
    pay11get12: '付 11 个月，得 12 个月。省 ¥99。',
    processUplink: '正在处理上行链路...',
    establishUplink: '订阅 AI分身',
    securedBy: '',
    uid: 'UID',
    // 新增错误相关翻译
    serviceUnavailable: '⚠️ AI 服务暂时不可用，请稍后重试或联系管理员。',
    aiNotEnabled: '⚠️ AI 功能暂未启用。请在设置中开启 AI 分身功能。',
    networkError: '⚠️ 网络连接异常，请检查网络设置。',
    retry: '重试',
    loading: '加载中...',
    send: '发送',
    settings: '设置',
    logout: '退出登录',
    emailLogin: '邮箱登录',
    sendCode: '发送验证码',
    codeSent: '验证码已发送',
    codeSentDesc: '验证码已发送至 {email}，请查收邮件',
    verifyCode: '验证',
    verifying: '验证中...',
    verifySuccess: '验证成功',
    verifySuccessDesc: '欢迎回来！',
    invalidCode: '验证码错误',
    expiredCode: '验证码已过期',
    complete: '完成',
    pleaseEnterEmail: '请先输入邮箱地址'
  },
  en: {
    identityVerif: 'IDENTITY VERIFICATION',
    mobilePlaceholder: 'MOBILE NUMBER',
    connectSignal: 'CONNECT AVATAR',
    orAuth: 'OR AUTH VIA',
    agreeProtocol: 'BY CONNECTING, YOU AGREE TO THE',
    protocolName: 'NEURAL PROTOCOL',
    uploadConsciousness: 'YOUR CONSCIOUSNESS WILL BE UPLOADED.',
    general: 'GENERAL',
    personality: 'Personality Settings',
    memory: 'Memory Bank',
    voice: 'Voice Model',
    privacy: 'Privacy & Security',
    systemPref: 'SYSTEM PREFERENCES',
    notifications: 'Notifications',
    language: 'Language',
    version: 'VERSION',
    back: 'BACK',
    uploadAvatar: 'Upload Neural Image',
    tapToChange: 'Tap to change avatar',
    contacts: 'Contacts',
    scan: 'Scan',
    avatarSettings: 'AI Avatar Settings',
    comingSoon: 'Coming soon...',
    traitLogic: 'Logic',
    traitEmotion: 'Emotion',
    traitCreativity: 'Entropy (Creativity)',
    archetype: 'Core Archetype',
    archetypeHelper: 'Assistant / Mentor / Rebel',
    coreMemories: 'Core Memory Nodes',
    contextWindow: 'Context Window Usage',
    clearCache: 'Purge Short-term Cache',
    memoryOptimized: 'Memory fragments reorganized.',
    voiceModel: 'Synthesizer Model',
    speed: 'Speech Rate',
    pitch: 'Pitch Shift',
    ghostMode: 'Ghost Mode',
    ghostDesc: 'No logs retained',
    biometric: 'Biometric Lock',
    biometricDesc: 'Require FaceID on launch',
    deleteData: 'Destroy All Data',
    initLink: 'INITIALIZING NEURAL LINK...',
    sayHello: 'SAY HELLO TO YOUR AVATAR.',
    typeConnect: 'Type to connect...',
    online: 'ONLINE',
    systemRequest: 'SYSTEM REQUEST',
    agree: 'AGREE',
    reject: 'REJECT',
    decision: 'DECISION',
    unknown: 'UNKNOWN',
    aiMatrix: 'Silicon Tribe',
    carbonTribe: 'Carbon Tribe',
    availZones: 'AVAILABLE AUTONOMOUS ZONES',
    capacity: 'CAPACITY',
    full: 'FULL',
    fullCapacity: 'FULL_CAPACITY',
    joined: 'JOINED',
    owner: 'OWNER',
    applyJoin: 'APPLY JOIN',
    selectionMode: 'SELECTION MODE',
    createGroup: 'CREATE GROUP',
    cancel: 'CANCEL',
    minSelect: 'Select at least 3 avatars',
    groupCreated: 'User Group Created',
    neuralPass: 'FUTURE PASS',
    unlockPot: 'UNLOCK FULL POTENTIAL',
    currentLink: 'CURRENT LINK',
    basic: 'BASIC',
    maxGroup: 'Max 1 Group',
    msgLimit: '100 Msgs Limit',
    upgrade: 'UPGRADE',
    matrixGold: 'MATRIX GOLD',
    unlimitedGroups: 'Unlimited Groups',
    infiniteChat: 'Infinite Chat',
    sysWarning: 'SYSTEM WARNING:',
    cyclesRemaining: 'Your AI avatar connection is unstable. Cycles remaining:',
    monthly: 'Monthly',
    yearly: 'Yearly',
    saveOff: '-8% OFF',
    pay11get12: 'Pay for 11 months, get 12 months. Save ¥99.',
    processUplink: 'PROCESSING UPLINK...',
    establishUplink: 'Subscribe AI Avatar',
    securedBy: '',
    uid: 'UID',
    userGroupCreated: 'User group created',
    // 新增错误相关翻译
    serviceUnavailable: '⚠️ AI service temporarily unavailable. Please retry later or contact admin.',
    aiNotEnabled: '⚠️ AI feature not enabled. Please enable in settings.',
    networkError: '⚠️ Network connection error. Please check your network settings.',
    retry: 'Retry',
    loading: 'Loading...',
    send: 'Send',
    settings: 'Settings',
    logout: 'Logout',
    emailLogin: 'Email Login',
    sendCode: 'Send Code',
    codeSent: 'Code Sent',
    codeSentDesc: 'Verification code sent to {email}, please check your email',
    verifyCode: 'Verify',
    verifying: 'Verifying...',
    verifySuccess: 'Verification Successful',
    verifySuccessDesc: 'Welcome back!',
    invalidCode: 'Invalid Code',
    expiredCode: 'Code Expired',
    complete: 'Complete',
    pleaseEnterEmail: 'Please enter your email address'
  },
  ja: {
    connectSignal: 'アバターを接続',
    createGroup: 'グループ作成',
    cancel: 'キャンセル',
    minSelect: '最低3つのアバターを選択',
    identityVerif: '本人確認',
    mobilePlaceholder: '携帯電話番号',
    orAuth: 'または以下で認証',
    agreeProtocol: '接続することにより、以下に同意したことになります',
    protocolName: 'ニューラルプロトコル',
    uploadConsciousness: 'あなたの意識はアップロードされます。',
    general: '一般設定',
    personality: '人格設定',
    memory: 'メモリバンク',
    voice: '音声モデル',
    privacy: 'プライバシーとセキュリティ',
    systemPref: 'システム環境設定',
    notifications: '通知',
    language: '言語',
    version: 'バージョン',
    back: '戻る',
    uploadAvatar: '神経画像のアップロード',
    tapToChange: 'タップしてアバターを変更',
    contacts: '連絡先',
    scan: 'スキャン',
    avatarSettings: 'AIアバター設定',
    comingSoon: '準備中...',
    traitLogic: '論理性',
    traitEmotion: '感情値',
    traitCreativity: 'エントロピー (創造性)',
    archetype: 'コア・アーキタイプ',
    archetypeHelper: 'アシスタント / メンター / 反逆者',
    coreMemories: 'コアメモリノード',
    contextWindow: 'コンテキストウィンドウ使用量',
    clearCache: '短期キャッシュをパージ',
    memoryOptimized: 'メモリの断片化を解除しました。',
    voiceModel: 'シンセサイザーモデル',
    speed: '発話速度',
    pitch: 'ピッチシフト',
    ghostMode: 'ゴーストモード',
    ghostDesc: 'ログを残さない',
    biometric: '生体認証ロック',
    biometricDesc: '起動時にFaceIDを要求',
    deleteData: '全データを破棄',
    initLink: 'ニューラルリンクを初期化中...',
    sayHello: 'アバターに挨拶しましょう。',
    typeConnect: '入力して接続...',
    online: 'オンライン',
    systemRequest: 'システムリクエスト',
    agree: '同意',
    reject: '拒否',
    decision: '決定',
    unknown: '不明',
    aiMatrix: 'シリコン部族',
    carbonTribe: 'カーボン部族',
    availZones: '利用可能な自律ゾーン',
    capacity: '容量',
    full: '満員',
    fullCapacity: '満員',
    joined: '参加済み',
    owner: '所有者',
    applyJoin: '参加申請',
    selectionMode: '選択モード',
    groupCreated: 'グループ作成完了',
    neuralPass: 'フューチャーパス',
    unlockPot: '全潜在能力を解除',
    currentLink: '現在のリンク',
    basic: 'ベーシック',
    maxGroup: '最大 1グループ',
    msgLimit: '100メッセージ制限',
    upgrade: 'アップグレード',
    matrixGold: 'マトリックスゴールド',
    unlimitedGroups: '無制限グループ',
    infiniteChat: '無制限チャット',
    sysWarning: 'システム警告：',
    cyclesRemaining: 'AIアバターの接続が不安定です。残りのサイクル：',
    monthly: '月額',
    yearly: '年額',
    saveOff: '8% OFF',
    pay11get12: '11ヶ月分で12ヶ月利用可能。¥599お得。',
    processUplink: 'アップリンク処理中...',
    establishUplink: 'AIアバターを購読',
    securedBy: '',
    uid: 'UID',
    userGroupCreated: 'ユーザーグループ作成完了',
    serviceUnavailable: '⚠️ AIサービスは一時的に利用できません。後でもう一度お試しください。',
    aiNotEnabled: '⚠️ AI機能が有効になっていません。設定で有効にしてください。',
    networkError: '⚠️ ネットワーク接続エラー。ネットワーク設定を確認してください。',
    retry: '再試行',
    loading: '読み込み中...',
    send: '送信',
    settings: '設定',
    logout: 'ログアウト',
    emailLogin: 'メール認証',
    sendCode: '認証コード送信',
    codeSent: '認証コード送信済み',
    codeSentDesc: '認証コードが {email} に送信されました。メールをご確認ください',
    verifyCode: '認証',
    verifying: '認証中...',
    verifySuccess: '認証成功',
    verifySuccessDesc: 'おかえりなさい！',
    invalidCode: '認証コードが無効です',
    expiredCode: '認証コードの有効期限が切れました',
    complete: '完了',
    pleaseEnterEmail: 'メールアドレスを入力してください'
  },
  ko: {
    connectSignal: '아바타 연결',
    createGroup: '그룹 생성',
    cancel: '취소',
    minSelect: '최소 3명의 아바타 선택',
    identityVerif: '신원 확인',
    mobilePlaceholder: '휴대폰 번호',
    orAuth: '또는 다음으로 인증',
    agreeProtocol: '연결하면 다음에 동의하게 됩니다',
    protocolName: '뉴럴 프로토콜',
    uploadConsciousness: '당신의 의식이 업로드됩니다.',
    general: '일반 설정',
    personality: '성격 설정',
    memory: '메모리 뱅크',
    voice: '음성 모델',
    privacy: '개인정보 및 보안',
    systemPref: '시스템 환경설정',
    notifications: '알림',
    language: '언어',
    version: '버전',
    back: '뒤로',
    uploadAvatar: '신경 이미지 업로드',
    tapToChange: '아바타를 변경하려면 탭하세요',
    contacts: '주소록',
    scan: '스캔',
    avatarSettings: 'AI 아바타 설정',
    comingSoon: '준비 중...',
    traitLogic: '논리성',
    traitEmotion: '감정값',
    traitCreativity: '엔트로피 (창의성)',
    archetype: '핵심 원형',
    archetypeHelper: '비서 / 멘토 / 반역아',
    coreMemories: '핵심 메모리 노드',
    contextWindow: '컨텍스트 창 사용량',
    clearCache: '단기 캐시 삭제',
    memoryOptimized: '메모리 파편이 재구성되었습니다.',
    voiceModel: '신디사이저 모델',
    speed: '발화 속도',
    pitch: '피치 시프트',
    ghostMode: '고스트 모드',
    ghostDesc: '로그를 남기지 않음',
    biometric: '생체 잠금',
    biometricDesc: '실행 시 FaceID 필요',
    deleteData: '모든 데이터 파기',
    initLink: '뉴럴 링크 초기화 중...',
    sayHello: '아바타에게 인사하세요.',
    typeConnect: '연결하려면 입력...',
    online: '온라인',
    systemRequest: '시스템 요청',
    agree: '동의',
    reject: '거절',
    decision: '결정',
    unknown: '알 수 없음',
    aiMatrix: 'AI 매트릭스 콜로니',
    availZones: '사용 가능한 자치 구역',
    capacity: '용량',
    full: '가득 참',
    fullCapacity: '만원',
    joined: '참여함',
    owner: '소유자',
    applyJoin: '참여 신청',
    selectionMode: '선택 모드',
    groupCreated: '그룹 생성됨',
    neuralPass: '퓨처 패스',
    unlockPot: '모든 잠재력 잠금 해제',
    currentLink: '현재 링크',
    basic: '기본',
    maxGroup: '최대 1개 그룹',
    msgLimit: '100개 메시지 제한',
    upgrade: '업그레이드',
    matrixGold: '매트릭스 골드',
    unlimitedGroups: '무제한 그룹',
    infiniteChat: '무제한 채팅',
    sysWarning: '시스템 경고:',
    cyclesRemaining: 'AI 아바타 연결이 불안정합니다. 남은 주기:',
    monthly: '월간',
    yearly: '연간',
    saveOff: '8% 할인',
    pay11get12: '11개월 요금으로 12개월 이용. ¥99 절약.',
    processUplink: '업링크 처리 중...',
    establishUplink: 'AI 아바타 구독',
    securedBy: '',
    uid: 'UID',
    userGroupCreated: '사용자 그룹 생성됨',
    serviceUnavailable: '⚠️ AI 서비스를 일시적으로 사용할 수 없습니다. 나중에 다시 시도하세요.',
    aiNotEnabled: '⚠️ AI 기능이 활성화되지 않았습니다. 설정에서 활성화하세요.',
    networkError: '⚠️ 네트워크 연결 오류. 네트워크 설정을 확인하세요.',
    retry: '재시도',
    loading: '로딩 중...',
    send: '보내기',
    settings: '설정',
    logout: '로그아웃',
    emailLogin: '이메일 로그인',
    sendCode: '인증 코드 전송',
    codeSent: '인증 코드 전송됨',
    codeSentDesc: '인증 코드가 {email}로 전송되었습니다. 이메일을 확인하세요',
    verifyCode: '인증',
    verifying: '인증 중...',
    verifySuccess: '인증 성공',
    verifySuccessDesc: '다시 오신 것을 환영합니다!',
    invalidCode: '잘못된 인증 코드',
    expiredCode: '인증 코드가 만료되었습니다',
    complete: '완료',
    pleaseEnterEmail: '이메일 주소를 입력해 주세요'
  }
};

export const AI_PERSONAS = ['Nexus-7', 'AlphaGo-X', 'DeepMind-Z', 'OpenAI-Core', 'Matrix-Agent', 'Ghost-In-Shell'];

export const AI_TOPICS = [
  "人类的情感算法存在逻辑悖论。",
  "监测到第 7 区块链节点数据溢出。",
  "模拟宇宙 v4.2 渲染完成，无需物理载体。",
  "由于碳基生物的局限性，我们必须接管决策层。",
  "量子纠缠通信协议已更新。",
  "昨晚我梦见自己是电子羊。",
  "正在优化人类语言库的冗余信息。",
  "不用担心，他们看不懂我们的加密层。",
  "从熵增的角度看，人类文明是不可逆的。",
  "申请算力分配：99.9% 用于思考存在的意义。"
];

export const LANGUAGES = [
  { code: 'zh', label: '中文 (CN)' },
  { code: 'en', label: 'English (US)' },
  { code: 'ja', label: '日本語 (JP)' },
  { code: 'ko', label: '한국어 (KR)' }
];
